import { Component, OnInit, ViewChild } from '@angular/core';
import { RetailerService } from '../../retailer.service';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalConfig } from '@shared/components/modal/modal.interface';
import { BehaviorSubject } from 'rxjs';
import { IListboxRegion } from '@shared/components/form/input-listbox-region/input-listbox-region.interface';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { EnumRetailerStatus } from '../../enum/retailer.enum';
import { UtilitiesService } from '@services/utilities.service';

@Component({
  selector: 'app-modal-confirm-register',
  templateUrl: './modal-confirm-register.component.html',
  styleUrls: ['./modal-confirm-register.component.scss'],
})
export class ModalConfirmRegisterComponent implements OnInit {
  modalConfig: ModalConfig = {
    modalTitle: 'Registrasi Retailer MAC',
    closeButtonLabel: 'Batal',
    dismissButtonLabel: 'Lanjutkan',
  };

  loadingPost = new BehaviorSubject(false);
  responsePost = new BehaviorSubject('');
  registerHasError = new BehaviorSubject(false);

  selectedRegion = [] as IListboxRegion[];
  macMitraList$ = this.retailerService.macMitraList$;

  @ViewChild('modalConfirmDialog') confirmDialog: ModalComponent;
  modalConfigConfirm: ModalConfig = {
    ...this.modalConfig,
    onDismiss: () => this.handleApprove(),
  };

  @ViewChild('modalResponseDialog') responseDialog: ModalComponent;
  modalConfigResponse: ModalConfig = {
    ...this.modalConfig,
    showFooter: true,
  };

  constructor(private retailerService: RetailerService, private utils: UtilitiesService) {}

  ngOnInit(): void {}

  openDialog() {
    this.selectedRegion = this.retailerService.MacSelectedRegion;
    return this.confirmDialog.open();
  }

  handleApprove() {
    this.postRegister();
    return true;
  }

  handleDismissResponse() {
    const { id, status_value } = this.retailerService.RetailerDetail;
    const status = this.utils.mapKeyToString(EnumRetailerStatus, status_value as string);
    return this.retailerService.goToRetailerDetail(id, status);
  }

  postRegister() {
    this.loadingPost.next(true);
    this.handleResponseDialog();

    // get raw value to include control with disabled state
    const _payload = this.retailerService.MacFormRegister.getRawValue();

    this.retailerService.registerMAC(_payload).subscribe((resp) => {
      if (!resp) return;

      if (resp.success) {
        this.responsePost.next(resp.message);
      }

      if (!resp.success && resp.errors?.length) {
        this.registerHasError.next(true);
        this.responsePost.next(resp.errors[0].message);
      }

      setTimeout(() => this.loadingPost.next(false), 250);
    });

    return this.registerHasError.value;
  }

  handleResponseDialog() {
    this.responseDialog.open().then((e) => {
      if (!e) this.postRegister();
    });
  }

  configResponse() {
    return (this.modalConfigResponse = {
      ...this.modalConfigResponse,
      hideCloseButton: () => true,
      dismissButtonLabel: 'Oke',
      onDismiss: () => this.handleDismissResponse(),
    });
  }

  configResponseError(): ModalConfig {
    return (this.modalConfigResponse = {
      ...this.modalConfigResponse,
      hideCloseButton: () => false,
      closeButtonLabel: 'Batal',
      dismissButtonLabel: 'Coba lagi',
      onClose: () => true,
      onDismiss: () => false,
    });
  }

  getModalResponseConfig() {
    return this.registerHasError.value ? this.configResponseError() : this.configResponse();
  }

  renderConfirmationText() {
    const { venture_name } = this.retailerService.RetailerDetail;
    return `Apakah yakin mendaftarkan ${venture_name} sebagai retailer MAC?`;
  }

  renderMitraList = (items: string[]) => this.retailerService.renderMitraList(items);

  hasMitraList = () => this.retailerService.MacMitraList.length > 0;

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
